enum ImageEditorSize {
  INHERIT_SIZE = 'inherit-size',
  FIXED_SIZE = 'fixed-size',
  FIXED_HEIGHT = 'fixed-height',
}
export { ImageEditorSize };
